export default __webpack_public_path__ + "static/media/user-item-icon.e25ba9c9.svg";